<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Heap :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3">
            <span class="text-h4 mr-1">{{ heap }}</span>
            <span class="text-h7">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">System :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ system }}</v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6"> </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Application :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ application }}</v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      heap: 0,
      system: 0,
      application: 0,
      contextmenuUrl: '/views/detailview/java/jm',
    };
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => every(key, response.length ? response[response.length - 1].data : []));
    },
    wsDataHandler(key, response) {
      if (key.name == 'rawJavaHeap') response.forEach(res => (this.heap = res.usedMemoryRate));
      else if (key.name == 'rawJavaSstmThrd') response.forEach(res => (this.system = res.activeThreadsCount));
      else if (key.name == 'rawJavaApplThrd') response.forEach(res => (this.application = res.activeThreadsCount));
    },
  },
  watch: {},
  created() {
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'rawJavaHeap', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['usedMemoryRate'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: 'rawJavaSstmThrd', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['activeThreadsCount'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: 'rawJavaApplThrd', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['activeThreadsCount'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
  },
};
</script>
